<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <div class="label">台账类型：</div>
        <Select v-model="search.type" style="width: 7.5em;margin-right: 10px" placeholder="选择台账类型" clearable>
          <Option v-for="item in wasteTypeEnum" :key="item.id" :value="item.id">{{ item.name }}</Option>
        </Select>
        <div class="label">固废名称：</div>
        <Select v-model="search.wasteTypeId" style="width: 15em" placeholder="选择固废名称筛选" clearable>
          <Option v-for="item in wasteTypeList" :key="item.id" :value="item.id">{{ item.wasteName }} - {{
          item.wasteTypeName }}({{ item.wasteTypeCode }})</Option>
        </Select>
        <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px; margin-left: 10px"
          @on-change="dateSelect($event)"></DatePicker>
        <i-input prefix="ios-search" placeholder="输入固废关键字" v-model="search.searchName"
          style="width: auto; margin-left: 10px" />
        <i-button type="default" @click="searchFunc" style="margin-left: 1em">搜索</i-button>
      </div>
      <div class="active">
        <i-button type="primary" @click="addData">添加</i-button>
        <i-button type="error" style="margin-left: 1em;">批量删除</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :max-height="table.maxHeight" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer :page-size="40" @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)" style="text-align: right; margin-top: 1em" />
      <Spin fix v-show="table.loading"></Spin>
    </div>

    <!-- 表单对话框 -->
    <Modal :title="modal.title" v-model="modal.show" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="数字识别码：" prop="numericIdentifier">
          <i-input v-model="formValidate.numericIdentifier" placeholder="固废数字识别码"></i-input>
        </FormItem>
        <FormItem label="固废重量：" prop="wasteWeight">
          <i-input v-model="formValidate.wasteWeight" placeholder="输入固废重量"></i-input>
        </FormItem>
        <FormItem label="固废名称：" prop="wasteName">
          <i-input v-model="formValidate.wasteName" placeholder="输入固废名称"></i-input>
        </FormItem>
        <FormItem label="固废类型：" prop="wasteTypeId">
          <Select v-model="formValidate.wasteTypeId" clearable>
            <Option v-for="item in wasteTypeList" :key="item.id" :value="item.id">{{ item.wasteName }} - {{
          item.wasteTypeName }}({{ item.wasteTypeCode }})</Option>
          </Select>
        </FormItem>
        <FormItem label="入库时间：" prop="inboundDate">
          <DatePicker type="date" placeholder="选择转移时间" v-model="formValidate.inboundDate"></DatePicker>
        </FormItem>
        <FormItem label="出库时间：" prop="outboundDate">
          <DatePicker type="date" placeholder="选择转移时间" v-model="formValidate.outboundDate"></DatePicker>
        </FormItem>
        <FormItem label="接收单位：" prop="receptionCompanyId">
          <Select v-model="formValidate.receptionCompanyId" clearable>
            <Option v-for="item in companyList" :key="item.id" :value="item.id">{{ item.companyName }}</Option>
          </Select>
        </FormItem>
        <FormItem label="备注：" prop="comment">
          <i-input v-model="formValidate.comment" type="textarea" :rows="2" placeholder="输入备注"></i-input>
        </FormItem>
      </Form>

      <div slot="footer">
        <i-button type="primary" @click="activeData">{{ modal.title }}</i-button>
        <i-button style="margin-left: 1em;" @click="modal.show = false">取消</i-button>
      </div>
    </Modal>

    <!-- 提示对话框 -->
    <alert-p :modalAlert="alert.show" title="警告提醒" content="确定要删除吗？" @cansel="alert.show = false" @makeSure="delData"
      :modal_loading="alert.loading"></alert-p>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 5.5em);
  position: relative;
}

.content {
  width: 700px;

  img {
    width: 100%;
  }
}
</style>

<script>
import toolbar from "../toolBar.vue"; // 操作栏组件
import { timeStamp } from "../../../util/common/date"; // 时间转化工具
import { emComputed } from "../../../util/common/fontSize"; // em转化工具
import { Resize } from "../../../util/common/resize";

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: "固废名称",
            key: "wasteName",
            align: "center",
          },
          {
            title: "包装编码",
            key: "numericIdentifier",
            align: "center",
          },
          {
            title: "固废编号",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  this.findWasteTypeCodeById(params.row.wasteTypeId)
                ),
              ]);
            },
          },
          {
            title: "固废重量(吨)",
            key: "wasteWeight",
            align: "center",
          },
          // {
          //   title: "备注信息",
          //   key: "wasteNotes",
          //   align: "center",
          // },
          {
            title: "入库操作员",
            key: "inboundOperatorName",
            align: "center",
          },
          {
            title: "入库时间",
            width: 180,
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  timeStamp(params.row.inboundDate, "yyyy-MM-dd HH:mm")
                ),
              ]);
            },
          },
          {
            title: "出库操作员",
            key: "outboundOperatorName",
            align: "center",
          },
          {
            title: "出库时间",
            width: 180,
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  timeStamp(params.row.outboundDate, "yyyy-MM-dd HH:mm")
                ),
              ]);
            },
          },
          {
            title: "接收单位",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  this.findReceptionCompanyName(params.row.receptionCompanyId)
                ),
              ]);
            },
          }, {
            title: "操作",
            align: "center",
            width: 180,
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "更新";
                        this.modal.show = true;
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        this.formValidate = {
                          id: params.row.id,
                          numericIdentifier: params.row.numericIdentifier,// 数字识别码
                          wasteWeight: params.row.wasteWeight,   // 固废重量
                          wasteName: params.row.wasteName,    // 固废名称
                          wasteNotes: params.row.wasteNotes,     // 备注信息
                          wasteTypeId: params.row.wasteTypeId,  // 固废类型ID
                          inboundDate: timeStamp(params.row.inboundDate, "yyyy-MM-dd",true), // 入库时间
                          outboundDate: timeStamp(params.row.outboundDate, "yyyy-MM-dd",true), // 出库时间
                          receptionCompanyId: params.row.receptionCompanyId,    // 接收单位ID

                        };
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.alert.id = params.row.id;
                        this.alert.show = true;
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 40,
        total: 0,
        loading: true,
        maxHeight: null,
      },
      // 查询
      search: {
        type: 0,
        searchName: null,
        wasteTypeId: null,
        startDate: null,
        endDate: null,
      },
      wasteTypeEnum: [{ "name": "库存记录", "id": 1 }, { "name": "出入记录", "id": 0 }], // 下拉列表
      wasteTypeList: [], // 下拉列表
      companyList: [], //接收单位
      // 表单
      modal: {
        show: false, // 表单modal显示隐藏
        title: "添加"
      },
      // 表单数据
      formValidate: {
        numericIdentifier: "",// 数字识别码
        wasteWeight: "",   // 固废重量
        wasteName: "",    // 固废名称
        wasteNotes: "",     // 备注信息
        wasteTypeId: "",  // 固废类型ID
        inboundDate: "", // 入库时间
        outboundDate: "", // 出库时间
        receptionCompanyId: "",    // 接收单位ID
      },
      // 验证
      ruleValidate: {
        wasteName: [{ required: true, message: "不能为空", trigger: "blur" }],
        wasteWeight: [{ required: true, message: "不能为空", trigger: "blur" }],
        wasteTypeId: [{ required: true, message: "请选择", trigger: "change", type: 'number' }],
        inboundDate: [{ required: true, type: "date", message: "不能为空" }]
      },
      // alert提示组件
      alert: {
        show: false,
        loading: false,
        id: ""
      },
    };
  },
  components: {
    toolbar,
  },
  created() {
    this.getWasteType(); // 下拉数据初始化
    this.getData();
    this.tableInit(); // 表格初始化
    this.getInventory(); //全部重量数据汇总
    this.getCompany(); //获取接收企业信息
    window.addEventListener("resize", this.tableInit);
  },
  methods: {
    addData() {
      // 打开表单添加
      this.modal.title = "添加";
      this.modal.show = true;
      this.formValidate = {
        numericIdentifier: "",// 数字识别码
        wasteWeight: "",   // 固废重量
        wasteName: "",    // 固废名称
        wasteNotes: "",     // 备注信息
        wasteTypeId: "",  // 固废类型ID
        inboundDate: "", // 入库时间
        outboundDate: "", // 出库时间
        receptionCompanyId: "",    // 接收单位ID
      };
      this.$refs.formValidate.resetFields(); // 清除验证错误
    },
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Waste.getWasteSolidInfoList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search,
        },
        ["uuid", "company"]
      ).then((res) => {
        if (res.code == 0) {
          // 获取成功
          let data = res.data.list;
          this.table.data = data;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    delData() {
      // 删除数据
      let id = this.alert.id; // 点击删除时对应的id
      if (id) {
        // 删
        this.alert.loading = true;
        this.$api.Waste.getWasteSolidInfoDel({ content: { id: id } }, [
          "uuid",
          "company"
        ])
          .then(res => {
            this.alert.show = false;
            if (res.code == 0) {
              this.alert.loading = false;
              this.$Notice.success({
                title: "删除成功",
                desc: ""
              });
              this.getData();
            } else {
              this.alert.loading = false;
              this.$Notice.warning({
                title: "删除失败",
                desc: res.message || "请联系管理员"
              });
            }
          })
          .catch(err => {
            this.alert.show = false;
            this.alert.loading = false;
          });
      } else {
        // 不存在id说明异常
        this.alert.show = false;
        this.$Notice.warning({
          title: "删除失败",
          desc: "数据异常，请联系管理员"
        });
      }
    },
    activeData() {
      //增、改操作
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          let params = this.formValidate;
          // 表单验证是否通过
          if (this.modal.title == "添加") {
            this.$api.Waste.postWasteSolidInfoAdd({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "添加成功",
                  desc: "添加成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "添加失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          } else {
            this.$api.Waste.postWasteSolidInfoEdit({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          }
        }
      });
    },
    // 搜索
    searchFunc() {
      this.getData();
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    // 获取固废类型
    getWasteType() {
      this.$api.Waste.getWasteSolidTypeAll({ content: "" }, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.wasteTypeList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取固废类型失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 获取库存总量数据
    getInventory() {
      this.$api.Waste.inventorySolid({ content: "" }, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          //this.wasteTypeList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取固废库存数据失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    getCompany() {
      this.$api.Waste.getWasteCompanyList({ content: "" }, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.companyList = res.data.list;
        } else {
          this.$Notice.warning({
            title: "获取企业信息失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },

    findWasteTypeCodeById(id) {
      const waste = this.wasteTypeList.find(waste => waste.id === id);
      return waste ? waste.wasteTypeName + " (" + waste.wasteTypeCode + ")" : null;
    },
    findReceptionCompanyName(id) {
      const company = this.companyList.find(company => company.id === id);
      return company ? company.companyName : null;
    },
    // 选择时间
    dateSelect(date) {
      this.search.startDate = date[0];
      this.search.endDate = date[1];
    },
    // 表格高度计算
    tableInit() {
      let headerH = emComputed(14.5); // header高度7em加操作栏5.5em转换px， 2em的上下边距分页组件
      this.table.maxHeight = window.innerHeight - headerH - 32; // 32px的分页组件高度
      if (this.$route.path != "/chome/reportTable") {
        window.removeEventListener("resize", this.tableInit);
      }
    },
  },
};
</script>